//
// Javascript dependancies and modules are handled by Browserify / CommonJs
//
// A quick into is available here: https://ponyfoo.com/articles/a-gentle-browserify-walkthrough
//
// everything JS is loaded through this main js file. (even jquery and other 3rd party dependancies!)
// If your dependancy has an npm project, you can add it to package.json rather than the copy-and-paste approach
//


var $ 		= require('jquery');
var g 		= require('./modules/globals');


require('./modules/search');
require('./modules/anchorlinks');

// require('./modules/slideshow');
// require('./modules/checkout');
require('./modules/mobile_menu');
// require('./modules/modals');
// require('./modules/scroll_prompts');
// require('./modules/sectionfades');


$('document').ready(function(){


});

